const SPECIES = [
  {
    id: 'hg38',
    name: 'Homo sapiens (hg38)'
  },
  {
    id: 'mm10',
    name: 'Mus musculus (mm10)'
  },
  {
    id: 'dm6',
    name: 'Drosophila melanogaster (dm6)'
  },
  {
    id: 'ce11',
    name: 'Caenorhabditis elegans (ce11)'
  },
  {
    id: 'rn6',
    name: 'Rattus norvegicus (rn6)'
  },
  {
    id: 'xenTro9',
    name: 'Xenopus tropicalis (xenTro9)'
  }
];

const DESCRIPTIONS = [
  {
    id: 'gene',
    title: 'Column 1 - Gene name (displayed)',
    body: `refGene gene symbols are used but it is also possible to search for genes using ensemble IDs, entrez IDs
            or other alias gene names.<br>Alias gene names are not displayed in the table but are present in the export download file (column 22).`
  },
  {
    id: 'sgRNA',
    title: 'Column 2 - sgRNA + NGG (displayed)',
    body: `20 nucleotide long sgRNA plus NGG PAM site.`
  },
  {
    id: 'position',
    title: 'Column 3 - Position (displayed)',
    body: `Gene coordinates for a 30 nucleotide (nt) stretch around the sgRNA. The 30nt include 4nt+23nt sgRNA + 3nt.`
  },
  {
    id: 'exon',
    title: 'Column 4 - Exon number (displayed)',
    body: `Exon number where the sgRNA cuts according to the refGene gene annotation. In some instance sgRNAs are
            displayed that cut only in isoform specific exons in such cases the string 'isoform specific exon' will appear instead of an exon number.<br>
            Isoform specific sgRNAs are heavily penalized and will be avoided by the sgRNA selection algorithm selecting top sgRNAs per gene whenever possible.`
  },
  {
    id: 'autoPick',
    title: 'Column 5 - Auto-pick "top10" (displayed)',
    body: `A guide selection algorithm that can be accessed via the Github repository GMICHLITS/VBC-score selects the top sgRNA for each gene.
            Selection is based on VBC-score and includes penalties for sgRNAs with predicted off-targets and high copy number (that is perfect matches elsewhere in the genome including intergenic regions).<br>
            Further the Selection algorithm avoids sgRNAs that have a stretch of 4 or more consecutive T-nucleotides which may act as a termination sequence for pol-III transcription.`
  },
  {
    id: 'vbcScore',
    title: 'Column 6 - VBC-score (displayed)',
    body: `The VBC-score is the primary ranking parameter for sgRNAs with the aim to generate high efficiency loss of function mutations.<br>
            It combines sgRNA activity (column 8), predicted frameshift generation (inDelphi, column 9) and the Bioscore (column 10).`
  },
  {
    id: 'distance',
    title: 'Column 7 - Distance start=0 stop=1 (displayed)',
    body: `Gives the distance of the sgRNA cut-site within the transcript. The distance score is incorporated into the VBC-score but has only a very minor contribution and is therefore also displayed separately.`
  },
  {
    id: 'activity',
    title: 'Column 8 - sgRNA activity 0=bad 1=good (displayed)',
    body: `sgRNA activity score predicts cutting efficiency of a sgRNA based on the 30nt sgRNA sequence only.
            The score combines two separate scores with close to equal contribution. First the sgRNA activity score as described by John G. Doench 2016 for optimized activity and the newly derived tracr_v2 score which showed correlation with efficiency if applied with improved tracr systems.`
  },
  {
    id: 'frameshift',
    title: 'Column 9 - Frameshift ratio inDelphi (displayed)',
    body: `Frameshift ratio as predicted using the DNA-repair prediction algorithm by Wang et al 2018 named inDelphi.<br>
            While the prediction shows correlation with experimentally determined editing outcomes it is important to be aware that while for some instances the prediction are very accurate they are also wrong in many cases.<br>
            Bioscore and sgRNA activity are more robust measures and are weighed heavier for generation of the VBC score.`
  },
  {
    id: 'bioscore',
    title: 'Column 10 - Bioscore 0=bad 1=good (displayed)',
    body: `The Bioscore is a predictor of sites that will be very sensitive to editing and are likely to disturb protein function.<br>
            It is based on Pfam annotations, phylogenetic conservation, AA identities surrounding the cut site (bulky hydrophobic AA are often indicators of very sensitive sites) and exon size.`
  },
  {
    id: 'OT90',
    title: 'Column 11 - Likely off-targets OT>90 (displayed)',
    body: `Gives the number of likely expected Off-targets (OT) (with an Off-target score greater than 90 (range 0-100)). The OT score was described previously in Michlits et al. 2017.<br>
            Details including the predicted Off-targets are present in downloaded data tables.`
  },
  {
    id: 'aminoAcids',
    title: 'Column 12 - Cutting site amino acids (displayed)',
    body: `Displays the coded amino acids in vicinity of the CRISPR-cut site. e.g. “EPAEPE-/-VNLSGLF” indicated that the cut (3 positions upstream to the NGG Pam site) lies between the codons for amino acids E and V. The annotation "NLTHHV-R-KVHLCL" indicated that the crispr cut lies within the codon for R.`
  }
];

export {
  SPECIES,
  DESCRIPTIONS
}